/**
 * @module app.config.filter
 */
class Controller {
  /**
   * @param {app.track.filterService} appTrackFilterService
   * @param {angularGettext.Catalog} gettextCatalog
   * @ngInject
   */
  constructor(appTrackFilterService, gettextCatalog) {
    /**
     * @type {number}
     * @export
     */
    this.filterId;

    /**
     * @type {function(appx.FilterIdChangeEvent)}
     * @export
     */
    this.onChange;

    /**
     * @private
     */
    this.filterService_ = appTrackFilterService;

    this.gettextCatalog = gettextCatalog;
  }

  $onInit() {
    this.filterService_.updateList();
  }

  /**
   * @export
   */
  get selectedFilterName() {
    const selectedFilter = this.filters.find(filter => filter.id === this.filterId);
    if (selectedFilter) {
      return selectedFilter.name;
    }
    return this.gettextCatalog.getString('undefined filter');
  }

  /**
   * @export
   * @return {Array<appx.TrackFilter>}
   */
  get filters() {
    return this.filterService_.filtersListPending;
  }
}


/**
 * @const {!angular.Component}
 */
const component = {
  bindings: {
    'filterId': '<',
    'onChange': '&',
  },
  controller: Controller,
  templateUrl: 'js/app/config/filter/partial.html'
};

export default angular.module('appConfigFilterComponent', [])
  .component('appConfigFilter', component);
